import type {
  IMediaLibDialogItem,
  TElement,
} from "@editor/modules/media-lib/types";
import {
  type ComponentType,
  type ReactNode,
  createContext,
  useContext,
} from "react";
import type { IImagesPanelImage } from "../types";

type StockImagesViewType = "dialog" | "panel";

interface StockImagesCtxValue {
  view?: StockImagesViewType;
  isMultiSelect?: boolean;
  selectedItems?: IMediaLibDialogItem[];
  onSelect?: (item: IImagesPanelImage) => void;
  elementWrapper?: ComponentType<{ children: ReactNode; element: TElement }>;
}

const StockImagesCtx = createContext<StockImagesCtxValue | undefined>(
  undefined,
);

export const StockImagesProvider = ({
  children,
  view = "panel",
  isMultiSelect,
  onSelect,
  elementWrapper,
  selectedItems,
}: {
  children: ReactNode;
  view?: StockImagesViewType;
  isMultiSelect?: boolean;
  selectedItems?: IMediaLibDialogItem[];
  elementWrapper?: ComponentType<{ children: ReactNode; element: TElement }>;
  onSelect?: (item: IImagesPanelImage) => void;
}) => {
  return (
    <StockImagesCtx.Provider
      value={{
        view,
        isMultiSelect,
        onSelect,
        selectedItems,
        elementWrapper,
      }}
    >
      {children}
    </StockImagesCtx.Provider>
  );
};

export const useStockImagesCtx = () => {
  const ctx = useContext(StockImagesCtx);
  if (!ctx) {
    throw new Error(
      "useStockImagesCtx must be used within a StockImagesProvider",
    );
  }
  return ctx;
};
